import { render, staticRenderFns } from "./CategoriasForm.vue?vue&type=template&id=201ae316&scoped=true"
import script from "./CategoriasForm.vue?vue&type=script&lang=js"
export * from "./CategoriasForm.vue?vue&type=script&lang=js"
import style0 from "./CategoriasForm.vue?vue&type=style&index=0&id=201ae316&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201ae316",
  null
  
)

export default component.exports